module.exports = __webpack_public_path__ + "img/common-file-text-download.601295c1.svg";